import Settings from '@/pages/Settings'

export default {
    path: '/settings',
    name: 'Settings',
    component: Settings
}


// WEBPACK FOOTER //
// ./src/router/settings.js